module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Pompeii.b633ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Pompeii.jpg
// module id = yXfF
// module chunks = 0